import { useMemo } from "react";
import type { ChartNode, ChartEdge } from "../../../../types/api-types";

/**
 * Hook to filter nodes and edges, removing nodes with no label AND no details
 */
const useFilteredChartData = (nodes: ChartNode[], edges: ChartEdge[]) => {
  const filteredNodes = useMemo(
    () =>
      nodes.filter(
        (node) =>
          (node.label && node.label.trim() !== "") ||
          (node.details && node.details.length > 0),
      ),
    [nodes],
  );

  const validNodeIds = useMemo(
    () => new Set(filteredNodes.map((node) => node.id)),
    [filteredNodes],
  );

  const filteredEdges = useMemo(
    () =>
      edges.filter(
        (edge) =>
          validNodeIds.has(edge.node1Id) && validNodeIds.has(edge.node2Id),
      ),
    [edges, validNodeIds],
  );

  return {
    filteredNodes,
    filteredEdges,
    validNodeIds,
  };
};

export default useFilteredChartData;
